// Zet "Nu besteld, morgen / overmorgen / dinsdag in huis" juist volgens de
// Belgische tijd van nu, in de browser.
//
// delivery-info.liquid kiest de zin al op de server, maar Shopify bewaart
// pagina's een tijd in de cache: wat daar "nu" is, is het moment waarop de
// pagina werd opgebouwd. Rond 17u kon een bezoeker zo nog "morgen" zien terwijl
// het al "overmorgen" was. Dit script rekent het moment opnieuw uit en past de
// tekst aan, ook in kaarten die later inladen (filteren, winkelmand, modal) en
// opnieuw elke minuut voor wie de pagina openlaat over 17u heen.
//
// Het vervangt alleen het dagwoord. De drie zinnen uit de vertaling
// (window.deliverySlotTexts) delen een begin ("Nu besteld, ") en verschillen
// in het dagwoord; dat verschil wordt hier afgeleid, zodat het in elke taal
// werkt. Zo blijft ook een aangepaste zin juist, zoals "Nu besteld, morgen
// geleverd en gemonteerd" bij montage op het gelijkvloers.
(() => {
  const texts = window.deliverySlotTexts;

  if (!texts || !texts.before_5 || !texts.after_5 || !texts.weekend) {
    return;
  }

  const sentences = [texts.before_5, texts.after_5, texts.weekend];

  // Gemeenschappelijk begin en einde van de drie zinnen; wat ertussen staat is
  // per zin het dagwoord.
  let prefixLength = 0;
  while (sentences.every((s) => s[prefixLength] === sentences[0][prefixLength]) && prefixLength < sentences[0].length) {
    prefixLength += 1;
  }
  // Niet midden in een woord knippen: terug tot na de laatste spatie.
  prefixLength = sentences[0].lastIndexOf(' ', prefixLength - 1) + 1;

  let suffixLength = 0;
  while (
    suffixLength < Math.min(...sentences.map((s) => s.length)) - prefixLength &&
    sentences.every((s) => s[s.length - 1 - suffixLength] === sentences[0][sentences[0].length - 1 - suffixLength])
  ) {
    suffixLength += 1;
  }
  // Idem aan het einde: vanaf de eerste spatie.
  const firstSuffixSpace = sentences[0].indexOf(' ', sentences[0].length - suffixLength);
  suffixLength = firstSuffixSpace === -1 ? 0 : sentences[0].length - firstSuffixSpace;

  const prefix = sentences[0].slice(0, prefixLength);
  const words = {};
  ['before_5', 'after_5', 'weekend'].forEach((slot, index) => {
    const sentence = sentences[index];
    words[slot] = sentence.slice(prefixLength, sentence.length - suffixLength).trim();
  });

  if (!prefix.trim() || Object.values(words).some((word) => !word)) {
    return;
  }

  // Langste eerst: "morgen" zit ook in "overmorgen".
  const candidates = Object.values(words).sort((a, b) => b.length - a.length);

  // Zelfde indeling als delivery-info.liquid, maar met de klok van nu in België.
  const currentSlot = () => {
    const parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Brussels',
      weekday: 'short',
      hour: 'numeric',
      hourCycle: 'h23',
    }).formatToParts(new Date());
    const weekday = parts.find((part) => part.type === 'weekday').value;
    const hour = parseInt(parts.find((part) => part.type === 'hour').value, 10);
    const day = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].indexOf(weekday) + 1;

    if ((day === 5 && hour >= 17) || day === 6 || day === 7) {
      return 'weekend';
    }

    return hour >= 17 ? 'after_5' : 'before_5';
  };

  const fixNode = (node, word) => {
    const text = node.nodeValue;
    const start = text.indexOf(prefix);

    if (start === -1) {
      return;
    }

    const restStart = start + prefix.length;
    const rest = text.slice(restStart);
    let match = null;
    let matchIndex = Infinity;

    candidates.forEach((candidate) => {
      const index = rest.indexOf(candidate);
      if (index !== -1 && index < matchIndex) {
        match = candidate;
        matchIndex = index;
      }
    });

    if (!match || match === word) {
      return;
    }

    const at = restStart + matchIndex;
    node.nodeValue = text.slice(0, at) + word + text.slice(at + match.length);
  };

  const fixWithin = (root) => {
    const word = words[currentSlot()];
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: (node) => (node.nodeValue.includes(prefix) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT),
    });
    const nodes = [];
    while (walker.nextNode()) {
      nodes.push(walker.currentNode);
    }
    nodes.forEach((node) => fixNode(node, word));
  };

  fixWithin(document.body);

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          fixWithin(node);
        } else if (node.nodeType === Node.TEXT_NODE) {
          fixNode(node, words[currentSlot()]);
        }
      });
    });
  }).observe(document.body, { childList: true, subtree: true });

  setInterval(() => fixWithin(document.body), 60 * 1000);
})();
